export const STATUS = {
  PENDING: 'PENDING',
  RESOLVED: 'RESOLVED',
  ERROR: 'ERROR',
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/constants.js